// extracted by mini-css-extract-plugin
module.exports = {"loading_box":"TxLoadingView_loading_box__28j8a","icon":"TxLoadingView_icon__2_T6I","text":"TxLoadingView_text__ZAOID","info":"TxLoadingView_info__2apeI"};